export default "__VITE_ASSET__Cyahi8xc__"